import * as React from 'react'
import { onSnapshot } from 'mobx-state-tree'
import qs from 'query-string'
import { rootStore } from '../store'

function isDebuggerEnabled() {
  if (typeof window !== 'undefined') {
    const { search } = window.location
    const searchObj = qs.parse(search)
    return searchObj.bl_debug == 1
  }

  return false
}

interface DebugContextType {
  register: (componentName: string, operations: Record<string, any>) => void
}

export const DebugContext = React.createContext<DebugContextType | null>(null)

export default function withDebugHelpers<P = any>(
  Component: React.ComponentType<P>
) {
  return (props: P) => {
    const [updates, setUpdates] = React.useState<Partial<P>>({})
    const [registered, setRegistered] = React.useState<Record<string, any>>({})

    React.useEffect(() => {
      if (isDebuggerEnabled()) {
        window.blDebug = {
          store: rootStore,
          Application: {
            update: setUpdates,
            registered,
          },
        }

        if (rootStore) {
          onSnapshot(rootStore, () => {
            window.blDebug = { ...window.blDebug, store: rootStore }
          })
        }
      }
    }, [registered])

    const registerComponent = (
      componentName: string,
      operations: Record<string, any>
    ) => {
      setRegistered((prev) => ({
        ...prev,
        [componentName]: operations,
      }))
    }

    return (
      <DebugContext.Provider value={{ register: registerComponent }}>
        <Component {...props} {...updates} />
      </DebugContext.Provider>
    )
  }
}

export const useDebugger = () => {
  const ctx = React.useContext(DebugContext)

  if (!ctx) {
    throw new Error('useDebugger must be used within a DebugProvider')
  }

  return { isDebuggerEnabled: isDebuggerEnabled(), register: ctx.register }
}
